import { HttpMethod } from '@guiker/http'

import { TenantApplication } from '../../entity'
import { paths } from './paths'
import { tenantApplicationByUserId, updatePartialTenantApplicationSchema } from './schemas'

const responseValidator = (payload: unknown) => Promise.resolve(payload as TenantApplication | undefined)

export const routes = {
  readOneTenantApplication: {
    path: paths.tenantApplication.one.withScope('user', ':userId'),
    method: HttpMethod.GET,
    authenticated: true,
    responseValidator,
    pathParamsValidator: (payload: unknown) => tenantApplicationByUserId.validate(payload),
  },
  updateTenantApplication: {
    path: paths.tenantApplication.one.withScope('user', ':userId'),
    method: HttpMethod.PATCH,
    authenticated: true,
    responseValidator,
    payloadValidator: (payload: unknown) => updatePartialTenantApplicationSchema.validate(payload),
    pathParamsValidator: (payload: unknown) => tenantApplicationByUserId.validate(payload),
  },
}
